import { history as historyRouter } from "instantsearch.js/es/lib/routers";
import { singleIndex as singleIndexMapping } from "instantsearch.js/es/lib/stateMappings";
import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";
import { reactive } from "vue";

export default {
  components: {},

  props: {
    startingIndex: {
      type: String,
      required: true,
    },

    filters: {
      type: String,
      required: false,
      default: "",
    },

    showBuyItNow: {
      type: Boolean,
      required: true,
    },

    showCollections: {
      type: Boolean,
      required: true,
    },

    defaultRefinement: {
      type: Array,
      default: null,
    },
  },

  computed: {},

  provide: {
    controlState: reactive({ showMobileControls: false }),
  },

  data() {
    // Algolia config
    const { searchClient } = instantMeiliSearch("https://cottonbureau.com/meilisearch", "fe42436054493f7bac7845cafd1599a77f3c0736390b6a4a43fbdeb896a14ef5", {
      paginationTotalHits: 1001,
    });

    return {
      firstSearch: true,
      showApparelFacets: false,
      showHatFacets: false,
      showPhoneCaseFacets: false,
      showDrinkwareFacets: false,

      hitsPerPage: 50,

      // Algolia config
      searchClient: searchClient,

      // Algolia routing
      routing: {
        router: historyRouter(),
        stateMapping: singleIndexMapping(this.startingIndex),
      },
    };
  },

  methods: {
    searchFunction(helper) {
      //helper.state.hitsPerPage = this.hitsPerPage;

      let filters = "";

      if (this.filters) {
        filters = this.filters;
      }

      if (this.person) {
        if (this.filters) {
          filters = `${filters} AND `;
        }

        filters = `${filters}product__seller__id=${this.person.id}`;
      } else {
        if (this.filters) {
          filters = `${filters} AND `;
        }

        filters = `${filters}(product__seller__seller_type NOT EXISTS OR product__seller__seller_type=normal)`;
      }

      helper.state.filters = filters;

      // Useful for debugging to ensure that memory doesn't become bloated
      // console.log(helper.state.hierarchicalFacets.length);

      if (this.firstSearch && this.defaultRefinement) {
        if (helper.state.query === "" && !helper.hasRefinements("product__collections__names") && !helper.hasRefinements("categories__lvl0") && !helper.hasRefinements("product__sales_method")) {
          for (const refinement of this.defaultRefinement) {
            if (refinement.facet === "available_for_sale") {
              helper.addDisjunctiveFacetRefinement(refinement.facet, refinement.value);
            } else {
              helper.addHierarchicalFacetRefinement(refinement.facet, refinement.value);
            }
          }
        }

        this.firstSearch = false;
      }

      let breadcrumbs = helper.getHierarchicalFacetBreadcrumb("categories__lvl0");
      // const inApparelExactly = breadcrumbs.includes('Apparel') && breadcrumbs.length === 1;
      // const inTees = breadcrumbs.includes('Tees');

      // if (!(inApparelExactly || inTees) && helper.hasRefinements('manufacturer_readable')) {
      //   helper.clearRefinements('categories.lvl0');
      // }

      // breadcrumbs = helper.getHierarchicalFacetBreadcrumb("categories__lvl0");
      const inApparel = breadcrumbs.includes("Apparel");
      const inHats = breadcrumbs.includes("Hats");
      const inPhoneCases = breadcrumbs.includes("Phone Cases");
      const inDrinkware = breadcrumbs.includes("Drinkware");

      if (inApparel) {
        // keep all facet refinements
      } else if (inPhoneCases || inHats) {
        // remove invalid facet refinements
        if (helper.hasRefinements("material_readable")) {
          helper.clearRefinements("material_readable");
        }

        if (helper.hasRefinements("sex_readable")) {
          helper.clearRefinements("sex_readable");
        }
      } else {
        // remove all facet refinements
        if (helper.hasRefinements("icon_color_palettized")) {
          helper.clearRefinements("icon_color_palettized");
        }

        if (helper.hasRefinements("material_readable")) {
          helper.clearRefinements("material_readable");
        }

        if (helper.hasRefinements("sex_readable")) {
          helper.clearRefinements("sex_readable");
        }
      }

      this.showApparelFacets = inApparel;
      this.showHatFacets = inHats;
      this.showPhoneCaseFacets = inPhoneCases;
      this.showDrinkwareFacets = inDrinkware;

      helper.search();

      if (helper.state.query !== "") {
        gtag("event", "search", {
          search_term: helper.state.query,
        });

        fbq("track", "Search");
      }
    },
  },

  mounted() {},
};
